import styles from './index.module.scss';

const TableLoader = () => {
	return <div className={styles.container}>{<div className={styles.loader}></div>}</div>;
};

export default TableLoader;
